module.exports = __webpack_public_path__ + "assets/img/176183a9c54e7ee0051d79537e693aec.png";